module.exports = __webpack_public_path__ + "assets/img/mecha-btn-b85b6061.png";